import { Component, Inject, Input, OnInit, Optional, Renderer2 } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractItem } from '@business/base/abstract-item';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { NormalModalComponent } from '@component/normal-modal/normal-modal.component';
import { PositionDto } from '@dto/position.dto';
import { WorkspaceItemContentDto } from '@dto/workspace-item-content-dto';
import { WorkspaceNewSaveDto } from '@dto/workspace-new-save-dto';
import { WorkspaceNewDto } from '@dto/workspacenew.dto';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: Constants.WINDOW_NAME_ASSET_SUMMARY + '-pop-up',
  templateUrl: './asset-summary-pop-up.component.html'
})
export class AssetSummaryPopUpComponent extends AbstractItem implements OnInit {
  @Input() override data: any;
  symbol: string = null;
  _messageQuote = new MessageQuote();
  override dialog: MatDialog;
  showClose = false;
  addInWksTooltip = Constants.TOOLTIP_ADD_WKS_TOOL;

  constructor(
    workspaceService: WorkspaceNewService,
    dialog: MatDialog,
    public dialogRef: MatDialogRef<AssetSummaryPopUpComponent>,
    itemService: AbstractItemService,
    @Optional() @Inject(MAT_DIALOG_DATA) public injectedSymbol,
    public _NotificationService: NotificationsService,
    private _render2: Renderer2,
  ) {
    super(workspaceService, dialog, itemService);
    this.dialog = dialog;
    const dialogClass = document.getElementsByClassName('mat-dialog-container')[0];
    if (dialogClass) {
      this._render2.addClass(dialogClass, 'remove-scroll');
    }
  }

  ngOnInit() {
    if (this.injectedSymbol) {
      this.data = this.injectedSymbol.injectedSymbol;
      this.showClose = this.injectedSymbol.showClose;
    }
  }

  addItemToWorkspace() {
    const userWorkspaceSelected: WorkspaceNewDto = this.workspaceService.getUserWorkspaceById(this.workspaceService.getWksSelectedId());
    const contentToUpdate: Array<WorkspaceItemContentDto> = JSON.parse(userWorkspaceSelected.JsonData).content;
    const workspaceUpdated: WorkspaceNewSaveDto = new WorkspaceNewSaveDto(userWorkspaceSelected.Name, [], userWorkspaceSelected.IndexTab);
    const itemSettings = this.workspaceService.getItemDefaultSettings(Constants.WINDOW_NAME_ASSET_SUMMARY);
    const wksItemPos: PositionDto = this.workspaceService.mountItemPositionDefaultSettings(itemSettings);
    const newContent = new WorkspaceItemContentDto(this.workspaceService.getNextContentItemId(contentToUpdate),
      this.data.symbol, this.data.company, Constants.WINDOW_NAME_ASSET_SUMMARY, wksItemPos,
      (itemSettings && itemSettings.showInGridster) || false, userWorkspaceSelected.Id || 0);
    // if (this.validateOnlyOneAssetAssigned(newContent.symbol.toString(), newContent.type, userWorkspaceSelected.Id) === true) {
    //   this._NotificationService.error('Erro', Constants.WORKSPACE_MSG015);
    //   return;
    // }
    if (contentToUpdate) {
      contentToUpdate.push(newContent);
      workspaceUpdated.content = contentToUpdate;
      if (workspaceUpdated.content.length > 10) {
        this._NotificationService.warn('', Constants.WORKSPACE_MSG011);
      } else {
        this.dialog.closeAll();
        const myEl = document.getElementById('toFocus') as HTMLInputElement;
        myEl.value = '';
        const dialogRef = this.dialog.open(NormalModalComponent, {
          data: {
            title: '',
            body: Constants.WKS_NEW_COMPONENT,
            redirectUrl: Constants.HOME_WKS_PATH,
            queryParams: {
              workspaceId: this.workspaceService.getWksSelectedId(),
              deleteCmp: true, workspaceUpdated: JSON.stringify(workspaceUpdated)
            }
          },
          panelClass: 'mat-modal-normal'
        });
        dialogRef.afterClosed().subscribe(confirmation => {
          if (confirmation) {
            this.workspaceService.addWksItens([newContent]);
          }
        });
      }
    }
  }
}
